var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 129,
    viewBox: "0 0 130 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9998 128.66C77.6895 128.66 90.0942 124.897 100.645 117.847C111.196 110.797 119.42 100.777 124.276 89.0531C129.132 77.3294 130.403 64.4289 127.927 51.9831C125.451 39.5373 119.341 28.1051 110.368 19.1321C101.395 10.1592 89.9627 4.04856 77.5168 1.57293C65.071 -0.902694 52.1706 0.367887 40.4469 5.22401C28.7232 10.0801 18.7027 18.3037 11.6528 28.8547C4.60276 39.4058 0.839844 51.8105 0.839844 64.5001C0.839844 81.5164 7.59954 97.8358 19.6319 109.868C31.6642 121.9 47.9836 128.66 64.9998 128.66Z",
    fill: "#7DFFBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0698 36.3401H100.43C101.292 36.3301 102.137 36.5831 102.851 37.0655C103.566 37.5479 104.117 38.2368 104.43 39.0401L113.67 62.6601L113.75 90.3401C113.75 91.5018 113.288 92.6159 112.467 93.4373C111.646 94.2587 110.531 94.7201 109.37 94.7201H20.1298C18.9682 94.7201 17.8541 94.2587 17.0327 93.4373C16.2113 92.6159 15.7498 91.5018 15.7498 90.3401L15.8998 62.5801L25.1198 39.0301C25.4315 38.2366 25.9751 37.5555 26.6797 37.0756C27.3844 36.5957 28.2173 36.3394 29.0698 36.3401Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8398 62.6301H45.6698C46.7466 62.6301 47.7793 63.0579 48.5407 63.8193C49.3021 64.5807 49.7298 65.6134 49.7298 66.6901V71.9001C49.7298 72.7382 50.0628 73.542 50.6554 74.1346C51.248 74.7272 52.0518 75.0601 52.8898 75.0601H76.6098C77.4479 75.0601 78.2517 74.7272 78.8443 74.1346C79.4369 73.542 79.7698 72.7382 79.7698 71.9001V66.7001C79.7685 66.1653 79.8729 65.6354 80.077 65.1411C80.281 64.6467 80.5808 64.1975 80.959 63.8193C81.3372 63.4411 81.7864 63.1413 82.2808 62.9373C82.7752 62.7332 83.305 62.6288 83.8398 62.6301H112.71",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7999 12.3901L66.8199 21.8301",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3898 15.5101L74.6898 24.1701",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2299 15.5701L58.9699 24.2001",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7498 37.0801V61.5801",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.75 38.0801V62.5801",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128.32,
    height: 128.32,
    fill: "white",
    transform: "translate(0.839844 0.340088)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigEmpty);
export default __webpack_public_path__ + "static/media/big_empty.053c6a1a.svg";
export { ForwardRef as ReactComponent };